import { Injectable } from '@angular/core';
import { IndexedDBAngular } from 'indexeddb-angular';
import { RcsAppConfig } from '../../assets/app.config';
import { Observable } from 'rxjs/Observable';
import { AsyncSubject } from 'rxjs/AsyncSubject';
import 'rxjs/add/observable/fromPromise';


@Injectable()
export class RcsConnectorIndexDbProvider{

  public database:IndexedDBAngular;

  constructor(private app_conf: RcsAppConfig) {
    this.database = new IndexedDBAngular('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    this.database.createStore(1,
      (evt) => {
        let keys = Object.keys(this.app_conf.db_collections);
        for (let key in keys){
          let col_name = keys[key];
          let objectstore = evt.currentTarget.result.createObjectStore(col_name);
          if (this.app_conf.db_collections[col_name].length !== 0){
            for(let index of this.app_conf.db_collections[col_name]){
              if (typeof(index) === 'object'){
                objectstore.createIndex(index[0], index[0], index[1]);
              }else{
                objectstore.createIndex(index, index, { unique: false });
              }
            }
          }
        }
    });
  }

  public create_store(){
    const observer = new AsyncSubject();
    this.database = new IndexedDBAngular('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    this.database.createStore(1,
      (evt) => {
        let keys = Object.keys(this.app_conf.db_collections);
        for (let key in keys){
          let col_name = keys[key];
          let objectstore = evt.currentTarget.result.createObjectStore(col_name);
          if (this.app_conf.db_collections[col_name].length !== 0){
            for(let index of this.app_conf.db_collections[col_name]){
              if (typeof(index) === 'object'){
                objectstore.createIndex(index[0], index[0], index[1]);
              }else{
                objectstore.createIndex(index, index, { unique: false });
              }
            }
          }
        }
        observer.next(true);
        observer.complete();
      });
    return observer;
  }

  public get_database_store():any{
    let kd_database = new IndexedDBAngular('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    let database_store = kd_database.createStore(1, (evt) => {
      let keys = Object.keys(this.app_conf.db_collections);
      let object_store;
      for (let key in keys){
        let col_name = keys[key];
        object_store = evt.currentTarget.result.createObjectStore(col_name);
        if (this.app_conf.db_collections[col_name].length !== 0){
          for(let index of this.app_conf.db_collections[col_name]){
            if (typeof(index) === 'object'){
				      object_store.createIndex(index[0], index[0], index[1]);
            }else{
              object_store.createIndex(index, index, { unique: false });
            }
          }
        }
      }
    });
    return database_store
  }

    // Lädt anhand eines bestimmten Index Daten aus der Collection
    public get_with_index(collection: string, categorie: string, key: string): AsyncSubject<any>{
        const item_observer = new AsyncSubject();
        const items = new Array();
        const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
        DBOpenRequest.onsuccess = function(event){
            const database = DBOpenRequest.result;
            const object_store = database.transaction('products', 'readonly').objectStore('products');
            object_store.openCursor().onsuccess = function(event){
                const cursor = event.target.result;
                if (cursor){
                    if (categorie === 'volltext'){
                        if ((cursor.value.name && cursor.value.name.match(new RegExp(key, "i"))) ||
                            (cursor.value.default_code_tmpl && cursor.value.default_code_tmpl.match(new RegExp(key, "i"))) ||
                            (cursor.value.seller_name && cursor.value.seller_name.match(new RegExp(key, "i"))) ||
                            (cursor.value.seller_number && cursor.value.seller_number.match(new RegExp(key, "i")))
                        ){
                            items.push(cursor.value);
                        }
                    }else{
                        if (cursor.value[categorie].match(new RegExp(key, "i"))){
                            items.push(cursor.value);
                        }
                    }
                    cursor.continue();
                }else{
                    item_observer.next(items);
                    item_observer.complete();
                }
            }
        }
        return item_observer;
    }

  // Sucht in der Datenbank über einen bestimmten Index
  public get_record_by_index(collection:string, index:string, search_value:string):AsyncSubject<any>{
    let async_object = new AsyncSubject();
    let result_list = [];

    this.database.openCursor(collection, (evt) => {
      var cursor = (<IDBOpenDBRequest>evt.target).result;
      if(cursor) {
        let item = cursor.value;
        if (index.indexOf('.') !== -1){
          async_object = this.search_for_submoduls(item, index, result_list, search_value, async_object);
        }else{
          if (item[index] && item[index].match(new RegExp(search_value, "i")) !== null){;
            result_list.push(item);
            async_object.next(result_list);
          }
        }
        cursor.continue();
      } else {
        async_object.complete();
      }
    });
    return async_object;
  }

  private search_for_submoduls(item, index, result_list, search_value, async_object){
    let index_array = index.split('.');
    let sub_modul_index = index_array[0];
    let attribute = index_array[1];
    if (item[sub_modul_index]){
      let sub_modul = item[sub_modul_index]
      if (sub_modul[attribute] && sub_modul[attribute].match(new RegExp(search_value, "i")) !== null){
       result_list.push(item);
       async_object.next(result_list);
      }
    }
    return async_object;
  }

  // Fügt einen Eintrag in die Collection hinzu
  public add(collection: string, value: any, key: any){
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    return Observable.create(observer => {
      DBOpenRequest.onsuccess = function(event){
          const database = DBOpenRequest.result;
          const transaction = database.transaction(collection, 'readwrite').objectStore(collection);
          const request = transaction.put(value, key);
          request.onsuccess = function(){ observer.next() },
          request.onerror = function (){ observer.error() }
          transaction.oncomplete = function(){ observer.complete() }
      }
    })
  }

  //Sucht mit dem IDBKeyRange in einem bestimmten Index
  public search(collection: string, index: string, key: string): AsyncSubject<any>{
    const item_observer = new AsyncSubject();
    const items = new Array();
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    DBOpenRequest.onsuccess = function(event){
      const database = DBOpenRequest.result;
      const object_store = database.transaction(collection, 'readonly').objectStore(collection);
      const request = object_store.index(index).openCursor(IDBKeyRange.bound(key, key + 'uffff'), 'prev');
      request.onsuccess = function(event){
        const cursor = event.target.result;
        if (cursor){
          items.push(cursor.value);
          cursor.continue();
        }else{
          item_observer.next(items);
          item_observer.complete();
        }
      }
    }
    return item_observer;
  }

  //Sucht mit dem IDBKeyRange in einem bestimmten Index
  public search_by_key(collection: string, key: string): AsyncSubject<any>{
    const item_observer = new AsyncSubject();
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    DBOpenRequest.onsuccess = function(){
      const database = DBOpenRequest.result;
      const object_store = database.transaction(collection, 'readonly').objectStore(collection);
      const request = object_store.get(key);
      request.onsuccess = function(event){
        item_observer.next(event.target.result);
        item_observer.complete();
      }
    }
    return item_observer;
  }

  //Leert eine Collection
  public clear(collection: string): AsyncSubject<any>{
    const item_observer = new AsyncSubject();
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    DBOpenRequest.onsuccess = function(){
      const database = DBOpenRequest.result;
      const object_store = database.transaction(collection, 'readwrite').objectStore(collection);
      const request = object_store.clear();
      request.onsuccess = function(event){
        item_observer.next(true);
        item_observer.complete();
      }
    }
    return item_observer;
  }
  // Fügt einen Eintrag in die Datenbank ein
  public add_record(collection:string, value:any, key:any):Observable<any>{
    let promise = this.database.add(collection, value, key);
    return Observable.fromPromise(promise);
  }

  // Updatet einen Record in der Datenbank
  public update_record(collection:string, value:any, key:any):Observable<any>{
    let promise = this.database.update(collection, value, key);
    return Observable.fromPromise(promise);
  }

  // Entfernt einen Record aus der Datenbank
  public delete_record(collection:string, key: any):Observable<any>{
    let promise = this.database.delete(collection, key);
    return Observable.fromPromise(promise);
  }

  // Gibt alle Einträge aus der Datenbank weiter
  public get_all_records(collection:string):Observable<any>{
    let promise = this.database.getAll(collection);
    return Observable.fromPromise(promise);
  }

  //Gibt alle Ergebnisse innerhalb einer DB zurück
  public get_all(collection: string): AsyncSubject<any>{
    const item_observer = new AsyncSubject();
    //const items = new Array();
    const DBOpenRequest = window.indexedDB.open('RCS_' + this.app_conf.db_prefix + '_Daten', 1);
    DBOpenRequest.onsuccess = function(event){
      const database = DBOpenRequest.result;
      const object_store = database.transaction(collection, 'readonly').objectStore(collection);
      const request = object_store.getAll();
      request.onsuccess = function(event){
        item_observer.next(event.target.result);
        item_observer.complete();
      }
    }
    return item_observer;
  }

  // Lädt einen Record anhand seines Keys
  public get_record_by_key(collection:string, key: any):Observable<any>{
    let promise = this.database.getByKey(collection, key);
    return Observable.fromPromise(promise);
  }

  public clear_collection(collection:string):Observable<any>{
    let promise = this.database.clear(collection);
    return Observable.fromPromise(promise);
  }

  public get_by_index(collection: string, index: string, search: string){
    let promise = this.database.getByIndex(collection, index, search);
    return Observable.fromPromise(promise);
  }

}



// WEBPACK FOOTER //
// ./src/providers/rcs-connector-index-db/rcs-connector-index-db.ts